import 'babel-polyfill'
import 'bootstrap'
import Swiper from 'swiper/bundle';

// Styling
import '../scss/style.scss'

// Fontawesome
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
library.add(faFacebookF, faTwitter, faInstagram, faLinkedinIn)
dom.watch()

// General
jQuery(document).ready(function($){
    if($('.login.wp-core-ui').length){
        $('#user_login').attr('placeholder', 'Gebruikersnaam of e-mailadres');
        $('#user_pass').attr('placeholder', 'Wachtwoord')
    }
    
    new Swiper('.swiper', {
        loop: true,
        autoplay: {
            delay: 5000,
        },

        pagination: {
            el: '.swiper-pagination',
        },
      
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    // On resize of page and at images loaded, set <header> min-height and <body> padding-top to height of <nav>
    function setHeaderHeight(){
        $('header').css('min-height', $('nav').height());
        $('body').css('padding-top', $('nav').height());
    }
    $(window).on('resize', setHeaderHeight);
    $(window).on('load', setHeaderHeight);

    $(window).on('scroll', function(){
        if($(window).scrollTop() > 0){
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    });

    $('#more-journeys').click(function(){
        $('.front-page__journey').removeClass('d-none');
        $(this).addClass('d-none');
    });
});


